module.exports = __webpack_public_path__ + "public/img/ptz-icon6.31216f0a.svg";